<template>
    <div class="mb-4 flex justify-between">
        <div>
            Dataset size:
            <input
                v-model.number="datasetSize"
                min="0"
                type="number"
                @update:model-value="page = 0"
            />
        </div>
        <div>
            <label>
                Clickable rows:
                <input
                    v-model="clickableRows"
                    type="checkbox"
                />
            </label>
        </div>
        <div>
            <label>
                Simulate Loading:
                <input
                    v-model="loading"
                    type="checkbox"
                />
            </label>
        </div>
    </div>
    <DsDataTable
        v-model:page="page"
        v-model:rows="rows"
        :clickable-rows
        :lazy="false"
        :loading
        :total-records="mockedData.length"
        :value="paginatedData"
    >
        <DsColumn
            class="w-1/12"
            field="index"
            header="Index"
            sortable
        />
        <DsColumn
            class="w-3/12"
            field="name"
            header="Name"
            sortable
        />
        <DsColumn
            class="w-6/12"
            field="email"
            header="Email"
        >
            <template #body="{ data }">
                <DsBadge
                    :text="data.email"
                    variant="error"
                />
            </template>
        </DsColumn>
        <DsColumn
            class="w-2/12"
            clickDisabled
            field="actions"
            header="Actions"
        >
            <template #body>
                <span class="flex gap-2">
                    <DsButton
                        size="sm"
                        variant="primary"
                    >
                        Action
                    </DsButton>
                    <DsButton
                        size="sm"
                        variant="secondary"
                    >
                        Action 2
                    </DsButton>
                </span>
            </template>
        </DsColumn>
        <template #empty>
            <div class="text-center">😭 No data available</div>
        </template>
    </DsDataTable>
</template>

<script setup lang="ts">
import DsBadge from '@/components/design-system/badge/DsBadge.vue';
import { DsColumn } from '@/components/design-system/table/DsColumn';
import DsButton from '@ds/button/DsButton.vue';
import DsDataTable from '@ds/table/DsDataTable.vue';
import { computed, ref } from 'vue';

function word() {
    return btoa(Math.random().toString()).slice(0, 8);
}

const page = ref(0);
const rows = ref(10);
const loading = ref(false);
const clickableRows = ref(true);
const datasetSize = ref(98);
// 98 items = 10 pages, last page incomplete
const mockedData = computed(() =>
    new Array(datasetSize.value).fill(0).map((_, i) => ({
        index: i,
        name: `${word()} ${word()}`,
        email: `${word()}${word()}@${word()}.com`,
    })),
);

const paginatedData = computed(() => {
    const start = page.value * rows.value;
    const end = start + rows.value;
    return mockedData.value.slice(start, end);
});
</script>
